import { baseThunk } from '../../fetch/basicThunk';
import { QUERY_GET_FACTORY_MODALITY_BAG, QUERY_GET_FACTORY_MODALITY_POOL, QUERY_GET_FACTORY_MODALITY_TYPE_DAYS_YEAR } from '../../fetch/constantQueries';

export const getFactoryModalityBag = baseThunk(`factoryBagGroups/getModalityBag`, QUERY_GET_FACTORY_MODALITY_BAG, "GET")

export const getFactoryModalityPool = baseThunk(`factoryBagGroups/getModalityPool`, QUERY_GET_FACTORY_MODALITY_POOL, "GET")

export const getFactoryModalityTypeDaysYear = baseThunk(`factoryBagGroups/getModalityTypeDaysYear`, QUERY_GET_FACTORY_MODALITY_TYPE_DAYS_YEAR, "GET")